import { Button } from 'components/common'
import Modal from 'components/modal'
import { ACTIONS, Action } from './utils'

type Props = {
  isOpen: boolean
  closeModal: () => void
  stores: any[]
  aggregators: any[]
  handleConfirmAction: React.MouseEventHandler<HTMLButtonElement>
  action?: Action
}

const ConfirmRunJobModal = ({
  isOpen,
  closeModal,
  stores,
  aggregators,
  handleConfirmAction,
  action = ACTIONS.INVENTORY,
}: Props) => {
  const title = `This will override the (${action}) of all items for the below stores${
    action !== ACTIONS.INVENTORY ? ' and aggregators:' : ':'
  } `

  return (
    <Modal
      width={700}
      title={title}
      titleClassname="text-xl text-[#DA2929] font-semibold max-w-xl"
      isOpen={isOpen}
      closeModal={closeModal}
      customStyle={{
        padding: '30px 45px',
      }}
    >
      <div>
        <div className="mt-5 grid grid-cols-2 text-base font-semibold">
          {/* List of Stores */}
          <ul>
            {stores?.map((store) => (
              <li className="list-inside list-disc" key={store.value}>
                {store.label}
              </li>
            ))}
          </ul>
          {/* List of Aggregators */}
          <ul>
            {aggregators?.map((aggregator) => (
              <li className="list-inside list-disc" key={aggregator.value}>
                {aggregator.label}
              </li>
            ))}
          </ul>
        </div>

        {/* Actions */}
        <div className="mt-12 flex  w-full items-center gap-5">
          <Button
            onClick={handleConfirmAction}
            className="w-full"
            buttonText="Confirm"
            type="button"
          />
          <Button
            className="w-full"
            buttonText="Cancel"
            variant="outline"
            type="button"
            onClick={closeModal}
          />
        </div>
      </div>
    </Modal>
  )
}

export default ConfirmRunJobModal
